/* Driven Mods UI: <dm-countdown data-end="ISO"> and <dm-sticky> (shows once the hero scrolls away). */
(function () {
  if (!customElements.get('dm-countdown')) {
    class DmCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end || '');
        if (isNaN(this.end)) { this.hidden = true; return; }
        this.setAttribute('role', 'timer');
        this.render();
        var self = this;
        this.iv = setInterval(function () { self.render(); }, 1000);
      }
      disconnectedCallback() { clearInterval(this.iv); }
      render() {
        var s = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        if (s === 0) {
          clearInterval(this.iv);
          var box = this.closest('[data-dm-expire]');
          if (box) box.hidden = true;
        }
        var units = [[Math.floor(s / 86400), 'd'], [Math.floor((s % 86400) / 3600), 'h'], [Math.floor((s % 3600) / 60), 'm'], [s % 60, 's']];
        var html = '';
        for (var i = 0; i < units.length; i++) {
          html += '<span class="dm-cd__u"><b>' + String(units[i][0]).padStart(2, '0') + '</b><i>' + units[i][1] + '</i></span>';
        }
        this.innerHTML = html;
      }
    }
    customElements.define('dm-countdown', DmCountdown);
  }
  if (!customElements.get('dm-sticky')) {
    class DmSticky extends HTMLElement {
      connectedCallback() {
        var hero = document.querySelector('[data-dm-hero]'), self = this;
        if (!hero || !('IntersectionObserver' in window)) { this.classList.add('is-on'); return; }
        this.io = new IntersectionObserver(function (es) { self.classList.toggle('is-on', !es[0].isIntersecting); });
        this.io.observe(hero);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    }
    customElements.define('dm-sticky', DmSticky);
  }
  if (!customElements.get('dm-try')) {
    /* Live configurator: button[data-mode], a text input (<3 types a heart) and button[data-color] swatches drive the <dm-led> inside. */
    class DmTry extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.led = this.querySelector('dm-led');
        this.input = this.querySelector('input');
        var on = this.querySelector('button[data-color][aria-pressed="true"]');
        this.color = on ? on.dataset.color : '#fff4e6';
        this.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b || !self.contains(b)) return;
          if (b.dataset.mode) {
            self.pick(b.dataset.mode);
            if (b.dataset.mode === 'text' && self.input) self.input.focus();
          } else if (b.dataset.color) {
            self.press('button[data-color]', b); self.color = b.dataset.color; self.pick('text');
          }
        });
        if (this.input) this.input.addEventListener('input', function () {
          var v = self.input.value.toUpperCase().replace(/[^A-Z0-9 !?.'&<-]/g, '');
          if (v !== self.input.value) self.input.value = v;
          self.pick('text');
        });
      }
      press(sel, btn) {
        this.querySelectorAll(sel).forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
      }
      pick(mode) {
        this.press('button[data-mode]', this.querySelector('button[data-mode="' + mode + '"]'));
        this.classList.toggle('is-text', mode === 'text');
        if (!this.led || !this.led.show) return;
        var text = (this.input && this.input.value.trim()) || (this.input && this.input.placeholder) || 'YOUR TEXT';
        this.led.show(mode, mode === 'text' ? { text: text, color: this.color } : {});
      }
    }
    customElements.define('dm-try', DmTry);
  }
})();
